import { showToast } from '../state/appState'

export interface BadgeInfo {
  emoji: string
  label: string
  description: string
}

/** Mirrors the badge keys awarded server-side in api/Shared/Services/GamificationService.cs. */
export const BADGE_CATALOG: Record<string, BadgeInfo> = {
  'first-practice': {
    emoji: '🌱',
    label: 'First Steps',
    description: 'Logged your first practice.',
  },
  'streak-7': {
    emoji: '🔥',
    label: 'Week Warrior',
    description: 'Practiced 7 days in a row.',
  },
  'streak-30': {
    emoji: '🔥',
    label: 'Dedicated',
    description: 'Practiced 30 days in a row.',
  },
  'streak-100': {
    emoji: '🔥',
    label: 'Century',
    description: 'Practiced 100 days in a row.',
  },
  'streak-365': {
    emoji: '🔥',
    label: 'Marathon',
    description: 'Practiced 365 days in a row.',
  },
  'active-5': {
    emoji: '🎻',
    label: 'Getting Started',
    description: '5 tunes at Active status.',
  },
  'active-20': {
    emoji: '🎻',
    label: 'Session Ready',
    description: '20 tunes at Active status.',
  },
  'interval-first': {
    emoji: '👂',
    label: 'Open Ears',
    description: 'Finished your first interval round.',
  },
  'interval-perfect': {
    emoji: '🎯',
    label: 'Perfect Pitch Gap',
    description: 'Got every interval right in a round of 10 or more.',
  },
  'interval-perfect-play': {
    emoji: '🎯',
    label: 'By Ear',
    description: 'A perfect round of 10 or more, played back on your instrument.',
  },
  'interval-rounds-10': {
    emoji: '👂',
    label: 'Tuning In',
    description: 'Finished 10 interval rounds.',
  },
  'interval-rounds-50': {
    emoji: '👂',
    label: 'Keen Ear',
    description: 'Finished 50 interval rounds.',
  },
  'interval-rounds-200': {
    emoji: '👂',
    label: 'Golden Ear',
    description: 'Finished 200 interval rounds.',
  },
}

export function getBadgeInfo(badgeKey: string): BadgeInfo {
  return BADGE_CATALOG[badgeKey] ?? { emoji: '🏅', label: badgeKey, description: '' }
}

/** Shows one toast per newly-earned badge key, e.g. from a logPractice() response. */
export function showBadgeToasts(newBadges: string[] | undefined) {
  for (const key of newBadges ?? []) {
    const badge = getBadgeInfo(key)
    showToast(`${badge.emoji} Badge earned: ${badge.label}!`, 'success')
  }
}
